<svg
  [style.opacity]="opacity"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 22 22"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
>
  @if(hasGradient){
  <defs>
    <linearGradient
      [attr.id]="gradientId"
      gradientUnits="userSpaceOnUse"
      x1="0"
      y1="0"
      x2="22"
      y2="22"
    >
      <stop offset="0%" [style.stop-color]="startColor" />
      <stop offset="100%" [style.stop-color]="endColor" />
    </linearGradient>
  </defs>
  }
  <path
    d="M5 12C5.26522 12 5.51949 12.1054 5.70703 12.293C5.89457 12.4805 6 12.7348 6 13V21C6 21.2652 5.89457 21.5195 5.70703 21.707C5.51949 21.8946 5.26522 22 5 22H1C0.734784 22 0.480505 21.8946 0.292969 21.707C0.105433 21.5195 0 21.2652 0 21V13C0 12.7348 0.105432 12.4805 0.292969 12.293C0.480505 12.1054 0.734784 12 1 12H5ZM13 0C13.2652 0 13.5195 0.105432 13.707 0.292969C13.8946 0.480505 14 0.734784 14 1V21C14 21.2652 13.8946 21.5195 13.707 21.707C13.5195 21.8946 13.2652 22 13 22H9C8.73478 22 8.48051 21.8946 8.29297 21.707C8.10543 21.5195 8 21.2652 8 21V1C8 0.734784 8.10543 0.480505 8.29297 0.292969C8.48051 0.105432 8.73478 0 9 0H13ZM21 8C21.2652 8 21.5195 8.10543 21.707 8.29297C21.8946 8.48051 22 8.73478 22 9V21C22 21.2652 21.8946 21.5195 21.707 21.707C21.5195 21.8946 21.2652 22 21 22H17C16.7348 22 16.4805 21.8946 16.293 21.707C16.1054 21.5195 16 21.2652 16 21V9C16 8.73478 16.1054 8.48051 16.293 8.29297C16.4805 8.10543 16.7348 8 17 8H21Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : (color || defaultColor)"
  />
</svg>
